import React from "react";

const ClinicalNotesIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0H1.5C0.675 0 0 0.72 0 1.6V14.4C0 15.28 0.6675 16 1.4925 16H10.5C11.325 16 12 15.28 12 14.4V4.8L7.5 0ZM6.74999 7.20001H5.24999V9.60001H2.99999V11.2H5.24999V13.6H6.74999V11.2H8.99999V9.60001H6.74999V7.20001ZM1.50001 1.09998H1.00001V1.59998V14.4V14.9H1.50001H10.5H11V14.4V5.59998V5.09998H10.5H7.25001V1.59998V1.09998H6.75001H1.50001ZM2.00001 13.9V2.09998H6.25001V5.59998V6.09998H6.75001H10V13.9H2.00001Z"
        fill={props.active?"#0085FF":props.color}
      />
    </svg>
  );
};

export default ClinicalNotesIcon;
